import React from "react";
import { Link } from "react-router-dom";
import "./PostNavigatingTawkPill.css";
import {
  TawkPill,
  TawkPillConfig,
  demoProps1 as tawkPillDemoProps1,
} from "../TawkPill/TawkPill";

export interface PostNavigatingTawkPillConfig {
  tawkPillConfig: TawkPillConfig;
  postId: string;
}

export const postNavigatingTawkPillDemoProps1: PostNavigatingTawkPillConfig = {
  tawkPillConfig: tawkPillDemoProps1,
  postId: "4663fd4b-f2cf-4215-a52b-4791175fa52b",
};

export function PostNavigatingTawkPill(
  props: PostNavigatingTawkPillConfig
): JSX.Element {
  return (
    <Link
      to={`/@${props.tawkPillConfig.authorUserHandle}/${props.postId}?primaryPostPreExpandedAndAutoplaying=true`}
      style={{ textDecoration: "none", textDecorationColor: "none" }}
    >
      <TawkPill {...props.tawkPillConfig} />
    </Link>
  );
}
